<template>
  <button
      :class="small? 'py-0.5 px-4' : ''"
      class="flex font-medium items-center justify-center gap-[8px] leading-7 w-fit h-fit py-1.5 px-4 text-primary-300 text-base rounded hover:text-primary-800 focus:text-primary-800 active:text-primary-900 disabled:text-grays-500"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: "button-text",
  props: {
    small: {
      type: Boolean,
      default: false,
    }
  },
}
</script>

<style>

</style>